import React from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import './discussion.scss';

const Discussion = ({languageId, deviceInfo, resultData}) => {
	return (
		<div className={'Discussion ' + deviceInfo.orientation}>
			<div className="Discussion-title">
				<span>{getText(resultData.title, languageId)}</span>
			</div>
			<div className="Discussion-text">
				{renderMarkdown(getText(resultData.text, languageId))}
			</div>

		</div>
	);
};

Discussion.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	resultData: PropTypes.object.isRequired
};

export default Discussion;
